import React from "react";
import { Routes, Route } from "react-router-dom";
import { AddNavigationProvider } from "common/modal/AddNavigation";
import ToLogin from "./pages/BeforeAndAfterAdmin/ToLogIn";
import ToLogout from "./pages/BeforeAndAfterAdmin/ToLogout";
import DlGroupList from "./pages/BeforeAndAfterAdmin/DlGroupList";
import AdminPhotoSeries from "./pages/BeforeAndAfterAdmin/AdminPhotoSeries";

export default function AdmApp() {
  return (
    <AddNavigationProvider>
      <Routes>
        <Route index element={<ToLogin />} />
        <Route path="l-out" element={<ToLogout />} />
        <Route path="dl-group-li" element={<DlGroupList />} />
        <Route path="photo-ser-li" element={<AdminPhotoSeries />} />
      </Routes>
    </AddNavigationProvider>
  );
}
